/**
 * BigBerkeyWaterFilters.com - Step Numbers
 * Version: FINAL v7 - Require minimum 2 sections
 */

(function() {
  'use strict';

  function createStepBadge(stepNumber) {
    const badge = document.createElement('span');
    badge.className = 'bbwf-step-number';
    badge.textContent = `STEP ${stepNumber}`;
    return badge;
  }

  function hasStepBadge(element) {
    return element.querySelector('.bbwf-step-number') !== null;
  }

  function getElementPosition(element) {
    return element.getBoundingClientRect().top + window.scrollY;
  }

  function injectStepNumbers() {
    console.log('=== BBWF Step Numbers ===');
    
    let sections = [];

    // 1. Find all fieldset legends
    const productForm = document.querySelector('.product-form, .product__info-wrapper, [data-product-form]');
    
    if (productForm) {
      const legends = productForm.querySelectorAll('fieldset legend');
      legends.forEach(legend => {
        if (!hasStepBadge(legend)) {
          const text = legend.textContent.toLowerCase();
          if (!text.includes('quantity')) {
            sections.push({ 
              element: legend, 
              text: legend.textContent.trim(),
              position: getElementPosition(legend)
            });
          }
        }
      });
    }

    // 2. Find the accessories heading
    const accessoriesHeading = document.querySelector('.product-checkbox-options__heading, h3.product-checkbox-options__heading');
    
    if (accessoriesHeading && !hasStepBadge(accessoriesHeading)) {
      sections.push({ 
        element: accessoriesHeading, 
        text: accessoriesHeading.textContent.trim(),
        position: getElementPosition(accessoriesHeading)
      });
    }

    console.log(`Found ${sections.length} sections`);

    // Require minimum 2 sections to activate
    if (sections.length < 2) {
      console.log('Only 1 section found, minimum 2 required. Skipping step numbers.');
      return;
    }

    // Sort by position (top to bottom)
    sections.sort((a, b) => a.position - b.position);

    sections.forEach((s, i) => {
      console.log(`  ${i + 1}. "${s.text}"`);
    });

    // Add step badges
    let stepNumber = 1;
    sections.forEach(section => {
      const badge = createStepBadge(stepNumber);
      section.element.insertBefore(badge, section.element.firstChild);
      console.log(`✓ STEP ${stepNumber}: "${section.text.substring(0, 40)}"`);
      stepNumber++;
    });

    console.log(`=== Added ${stepNumber - 1} step badges ===`);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectStepNumbers);
  } else {
    injectStepNumbers();
  }

  window.BBWF_StepNumbers = {
    reinject: injectStepNumbers,
    version: 'FINAL-v7'
  };
  
  console.log('BBWF Step Numbers FINAL-v7 loaded');
})();